<template lang='pug'>
  .ec-campaign-overview(v-loading="loading")
    .overview__header
      el-breadcrumb(
        separator="/"
        style="padding-bottom: 20px"
      )
        el-breadcrumb-item(
          :to="{ path: '/ec-campaign/list' }"
        ) {{ $t('项目列表') }}
        el-breadcrumb-item {{ data.campaign_name }}
      .header__right
          i.iconfont.icon-arrow_left(style="color:#3370D2")
          el-button(
            type="text"
            @click="$router.push('/ec-campaign/list')"
            style="width: 72px"
          ) {{ $t('返回') }}
    .ec-campaign-name
      p {{ data.campaign_name }}
    el-card
      p {{ $t('项目概览') }}
      el-row.title-row(
        :gutter="20"
      )
        el-col(:span="10") {{ $t('品类') }}
        el-col(:span="10") {{ $t('品牌') }}
      el-row.content-row(
        :gutter="20"
      )
        el-col(:span="10") {{ data.brand[0].brand_category_name }}
        el-col(:span="10") {{ data.brand[0].brand_name }}
      el-row.title-row(
        :gutter="20"
      )
        el-col(:span="10") {{ $t('投放渠道') }}
        el-col(:span="10") {{ $t('投放总预算') }}
      el-row.content-row(
        :gutter="20"
      )
        el-col(:span="10") {{ data.channel_name }} - {{ data.shop_name }}
        el-col(:span="10") {{ data.budget / 10000 | numberWithCommas(1) }} {{ $t('万元') }}
      el-row.title-row(
        :gutter="20"
      )
        el-col(:span="10") {{ $t('项目背景') }}
      el-row.content-row(
        :gutter="20"
      )
        el-col.break-all(:span="10") {{ data.remark != null ? data.remark : '—' }}
    el-card.ec-sub-brief__table
      .title
        p {{ $t('子项目管理') }}
        el-button(
          v-if="showAddCampaign"
          @click="handleAddCampaign"
          :disabled="data.status === 2"
        ) {{ $t('添加子项目') }}
      hr.divider
      el-table(
        :data="sowList"
        :row-class-name="tableRowClassName"
      )
        el-table-column(
          prop="sub_final_scope_name"
          :label="$t('子项目')"
        )
        el-table-column(
          prop="brand_line_name"
          :label="$t('品牌线')"
        )
        el-table-column(
          :label="$t('投放时间')"
          width="200px"
        )
          template(slot-scope="scope")
            span {{ scope.row.start_date }} ~ {{ scope.row.end_date }}
        el-table-column(
          prop="price"
          :label="$t('状态')"
        )
          template(slot-scope="scope")
            span {{ getSOWStatus(scope.row.status) }}
        el-table-column(
          :label="$t('操作')"
        )
          template(slot-scope="scope")
            el-button(
              type="text"
              @click='handleView(scope.row)'
            ) {{ $t('查看') }}
            el-button(
              type="text"
              :disabled="!canDeleteSOW || scope.row.status === 2 || scope.row.status === 3",
              @click='handleDelete(scope.row.sub_final_scope_id)'
            ) {{ $t('删除') }}
    el-dialog(
      :title="$t('提示')"
      :visible.sync="visible"
    )
      p(style="text-align:left;width:100%") {{ $t('子项目删除后将为失效状态，请确定是否继续。') }}
      el-form(
        ref="form"
        :model="form"
        :rules="rules"
      )
        el-form-item(
          :label="$t('备注') + ':'"
          prop="remark"
        )
          el-input(
            v-model="form.remark"
            type="textarea"
            :rows="3"
            style="width: 320px"
            :placeholder="$t('备注不多于500字')"
          )
      footer-button(
        :confirmButton="'确定'"
        @confirm="handleConfirm(2)"
        @cancel="handleCancel"
      )
</template>

<script>
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import { numberWithCommas } from '@/umcc/util'
export default {
  components: {
    FooterButton
  },
  data () {
    let validateIntro = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入备注')))
      } else if (value.length > 500) {
        callback(new Error(this.$t('备注不多于500字')))
      } else {
        callback()
      }
    }
    return {
      sowList: [],
      data: {},
      deletedId: null,
      visible: false,
      loading: false,
      form: {
        remark: ''
      },
      rules: {
        remark: [
          {
            required: true, validator: validateIntro, trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    canDeleteSOW () {
      return this.$store.state.common.user.permissions.includes('Delete_EC_SOW')
    },
    showAddCampaign () {
      return this.$store.state.common.user.permissions.includes('Management_EC_Campaign_C')
    }
  },
  mounted () {
    this.fetchData()
  },
  filters: {
    numberWithCommas
  },
  methods: {
    async fetchData () {
      const [res1, res2] = await Promise.all([this.getCampaignOverview(), this.getSowList()])
      this.data = res1
      this.sowList = res2
    },
    getCampaignOverview () {
      return axios.get('/management/ec/getCampaignOverview', {
        params: {
          campaign_id: this.campaignId
        }
      })
    },
    getSowList () {
      return axios.get('/management/ec/getSowList', {
        params: {
          campaign_id: this.campaignId
        }
      })
    },
    getSOWStatus (status) {
      switch (status) {
        case 0:
          return this.$t('草稿')
        case 1:
          return this.$t('进行中')
        case 2:
          return this.$t('已失效')
        case 3:
          return this.$t('完成')
      }
    },
    tableRowClassName ({row}) {
      return row.status === 2 ? 'disabled-row' : ''
    },
    handleConfirm () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.confirmDelete()
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.$refs['form'].clearValidate()
    },
    handleAddCampaign () {
      this.$store.commit('campaign/setSubFinalScopeId', null)
      this.$store.dispatch('campaign/updateECTab')
      this.$router.push({
        path: '/ec-campaign/process'
      })
    },
    handleView (row) {
      this.loading = true
      this.$store.commit('campaign/setSubFinalScopeId', row.sub_final_scope_id)
      this.loading = true
      axios.get('/management/ec/getTabList', {
        params: {
          sub_final_scope_id: row.sub_final_scope_id
        }
      })
        .then(res => {
          const arr = res.filter(i => i.can_view)
          arr.push({
            tab_name: 'tab_user',
            action: 'campaign-participant',
            version: 'v1'
          })
          this.$store.commit('campaign/setECTab', arr)
          const version = arr[0].version != null ? arr[0].version : 'v1'
          this.loading = false
          this.$router.push({
            path: arr[0].action + '-' + version
          })
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    handleDelete (id) {
      this.deletedId = id
      this.visible = true
    },
    confirmDelete () {
      this.loading = true
      axios.get('/management/ec/deleteSOW', {
        params: {
          sub_final_scope_id: this.deletedId,
          remark: this.form.remark,
          servlet_path: this.$route.path
        }
      })
        .then(res => {
          this.loading = false
          this.$message.success(this.$t('删除成功'))
          this.fetchData()
          this.visible = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang='stylus'>
.ec-campaign-overview
  .overview__header
    display flex
    align-items center
    justify-content space-between
    .header__right
      display flex
      align-items center
      i
        color $main
        margin-right: -2px;
      .el-button
        padding-top 8px
        width auto !important
  .title
    display flex
    justify-content space-between
    align-items center
  .title-row
    margin-bottom 0
    color #999999
  .content-row
    margin-top 0
    color #5e5e5e
    margin-left -10px !importan
  .ec-campaign-name
    display flex
    align-items center
    p
      font-size 18px
      color #2c3031
      margin-right 24px
    span
      font-size 12px
      color #808080
  .el-card__body
    > p
        margin 0
        color #2c3031
        font-size 16px
  .ec-sub-brief__table
    margin-top 24px
    .el-card__body
      padding-top 16px !important
      .title
        p
          margin 0
          color #2c3031
          font-size 16px
    .divider
      border-top 1px solid $gray2
      margin 16px 0
  .el-dialog
    width 452px
    .el-form
      width 100%
      .el-form-item__error
        margin-left 55px
    .el-dialog__body
      padding-left 24px
      padding-right 24px
      display flex
      flex-direction column
      align-items center
      .el-textarea
        textarea.el-textarea__inner
          height 90px
    .footer-button
      margin-top 0
      text-align right
      width 100%
  .el-table
    .disabled-row
      color $disabled
      td
        &:first-child
          text-decoration line-through
</style>
